module.exports = __webpack_public_path__ + "static/media/refresh.8c703f8f.svg";